/* eslint-disable no-param-reassign */

const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');
const { LOGALTY_IMPLEMENTATION, DOCUSIGN_IMPLEMENTATION } = require('../constants/steps');

const setInitialState = () => {
    return Immutable.Map().merge({
        contractUrl: '',
        loaded: false,
        status: null,
        lastUpdate: null,
        contractToken: '',
        implementation: null,
        envelopeId: null,
    });
};

const initialState = setInitialState();

const signReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.CONTRACT_URL:
            return state.merge({
                contractUrl: action.data.contractUrl,
                contractToken: action.data.contractToken,
                envelopeId: action.data.envelopeId,
            });

        case actionTypes.CONTRACT_STATUS:
            return state.merge({
                status: action.data.status,
                lastUpdate: action.data.lastUpdate,
            });

        case actionTypes.CONTRACT_LOADING:
            return state.merge({
                loaded: false,
            });

        case actionTypes.SET_ONBOARDING_IMPLEMENTATION: {
            const implementation =
                action.implementation === 'logalty' ? LOGALTY_IMPLEMENTATION : DOCUSIGN_IMPLEMENTATION;

            return state.merge({
                implementation,
                loaded: false,
            });
        }

        case actionTypes.CONTRACT_LOADED:
            return state.merge({
                loaded: true,
            });

        default:
            return state;
    }
};

module.exports = signReducer;
